


































import {
    Answer,
    Component,
    ComponentConfig,
    ComponentStyle,
    ComponentStyleDefinition,
    Prop,
    Vue,
    VueComponent,
    InjectComponent
} from "@zoovu/runner-browser-api";
import {AnswersConfiguration} from "../configuration";

@Component({})
export default class ChoiceAnswerView extends Vue {

    @Prop()
    answer: Answer;

    @Prop()
    inputType: string;

    @Prop()
    answerTextHeight: string;

    @Prop()
    imageHeight: string;

    @ComponentConfig(AnswersConfiguration)
    componentConfiguration: AnswersConfiguration;

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    @InjectComponent("InfoText")
    infoText: VueComponent;

    infoTextShown = false;

    enterPressed() {
        (this.$refs.choiceAnswerLabel as HTMLElement).click();
    }

    get answerTextContent(): string {
        // check if answerText contains html elements
        if(/<\/?[a-z][\s\S]*>/i.test(this.answer.answerText)) {
            return this.answer.answerText;
        }
        return this.answer.answerText.split('/').join('/<wbr>');
    }

    get infoTextContent(): string {
        // check if infoText contains html elements
        if(/<\/?[a-z][\s\S]*>/i.test(this.answer.infoText)) {
            return this.answer.infoText;
        }
        return this.answer.infoText.split('/').join('/<wbr>');
    }

    get disabled() {
        return this.answer.disabled || (this.answer.question && this.answer.question.readOnly);
    }

    get componentStateClasses() {
        return {
            'is-selected': this.answer.selected,
            'is-disabled': this.disabled,
            'has-image': this.showImage,
            'info-text-shown': this.infoTextShown
        };
    }

    get enabledAnswers(): ReadonlyArray<Answer> {
        return this.answer.question.answers.filter(answer => !answer.disabled);
    }

    get enabledAnswersLength() {
        return this.componentConfiguration.showDisabled ? this.answer.question.answers.length : this.enabledAnswers.length;
    }

    get answerWrapperStyle() {
        const numberOfAnswers = this.enabledAnswersLength;
        const maxAllowedAnswersPerRow = 4;
        const perRow = numberOfAnswers < maxAllowedAnswersPerRow ? numberOfAnswers : maxAllowedAnswersPerRow;
        const gutter = 15;
        return {width: 'calc( ' + (100 / perRow) + "% - " + gutter + "px )"};
    }

    get answerWrapperClass() {
        return  this.enabledAnswersLength < 5 ? 'normal-row' : 'full-row';
    }

    get showImage() {
        return this.componentConfiguration.showImages == true && this.answer.images != null && this.answer.images[0] != null;
    }

    showInfoText() {
        this.infoTextShown = true;
    }

    hideInfoText() {
        this.infoTextShown = false;
    }

    areImagesAvailable(): boolean {
        return this.componentConfiguration.showImages == true
    }

    get doesSomeAnswerHaveImage(): boolean {
        return this.answer.question.answers.some(answer => answer.images && answer.images.length > 0);
    }
}
